import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { IApiError } from '../../../react-core/Core/ApiError';
import { QuoteModel } from '../../Models/Models/Processes/Quote/QuoteModel';
import { QuoteErrors } from '../../Validation/Errors/Quote/QuoteErrors';

declare var IS_RUNNING_IN_APP_POOL;

export class QuoteContributionsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(model: QuoteModel): Promise<QuoteModel, IApiError<QuoteErrors>[]> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Quote/QuoteContributions/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.post<QuoteModel, IApiError<QuoteErrors>[]>(url, data);
  }
}

